import React, {useEffect, useState} from "react";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import Grid from "../../../components/Grid";
import {Card, Spinner} from "reactstrap";
import {useVsiAppContext} from "../../../stores/VsiApp";
import VerticalBarChart from "../../../components/VerticalBarChart";
import {databaseMissingIndexesDefs} from "../../../utils/gridColumnDefs/databases/databaseIndexesDefs";
import {integerFormatter, numberFormatter, percentageBarFormatter} from "../../../utils/gridFormatters";

export default function DatabaseFragmentation({title}) {
    useTitleFromComponent(title);

    const {theme, client, periodId} = useVsiAppContext();
    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/database_fragmentation_proc?client_id=${client.clientId}&period_id=${periodId}`);
    const [chartData, setChartData] = useState([]);
    const [chartCategories, setChartCategories] = useState([]);
    const [gridData, setGridData] = useState([]);

    useEffect(() => {
        setGridData(data?.recordset || []);

        setChartCategories(
            data?.recordset?.slice(0, 30).map(m => m.index_name)
        );

        setChartData([
            {
                name: "percent",
                data: data?.recordset?.slice(0, 30).map(m => m.avg_fragmentation_in_percent)
            }
        ]);

    }, [data, isLoading]);


    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Databases Fragmentation</VsiH4>
            {isLoading ? <Spinner color={"primary"}/> : (
                <div>
                    <VsiBubble autobotName='ColumnChart'>
                        <VerticalBarChart
                            categories={chartCategories}
                            series={chartData}
                            changeAxisTitle={true}
                            yTitle1={"Top 30 Fragmentation (%)"}
                            height={500}
                            axisMaxMin={{axis1Min: 0}}
                        />
                    </VsiBubble>
                    <VsiBubble>
                        <Grid addStyle
                              data={gridData}
                              isLoading={isLoading}
                              columnDefs={[
                                  {
                                      field: "device_name",
                                      headerName: "Instance Name",
                                  },
                                  {
                                      field: "database_name",
                                      headerName: "Database Name",
                                  },
                                  {
                                      field: "table_name",
                                      headerName: "Table Name",
                                  },
                                  {
                                      field: "index_name",
                                      headerName: "Index Name",
                                  },

                                  {
                                      field: "avg_fragmentation_in_percent",
                                      headerName: "Average Fragmentation Percent",
                                      cellRenderer: percentageBarFormatter,
                                      type: "numericColumn",
                                      cellStyle: {
                                          textAlign: "right"
                                      },
                                      aggFunc: "sum",
                                      filter: "agNumberColumnFilter",
                                      filterParams: {
                                          cellHeight: 20,
                                          debounceMs: 1000
                                      }
                                  },
                                  {
                                      field: "avg_fragment_size_in_pages",
                                      headerName: "Average Fragment Size in Pages",
                                      cellRenderer: numberFormatter,
                                      type: "numericColumn",
                                      cellStyle: {
                                          textAlign: "right"
                                      },
                                      aggFunc: "sum",
                                      filter: "agNumberColumnFilter",
                                      filterParams: {
                                          cellHeight: 20,
                                          debounceMs: 1000
                                      },
                                  },
                                  {
                                      field: "fragment_count",
                                      headerName: "Fragment Count",
                                      cellRenderer: integerFormatter,
                                      type: "numericColumn",
                                      cellStyle: {
                                          textAlign: "right"
                                      },
                                      aggFunc: "sum",
                                      filter: "agNumberColumnFilter",
                                      filterParams: {
                                          cellHeight: 20,
                                          debounceMs: 1000
                                      }
                                  },
                                  {
                                      field: "page_count",
                                      headerName: "Page Count",
                                      cellRenderer: integerFormatter,
                                      type: "numericColumn",
                                      cellStyle: {
                                          textAlign: "right"
                                      },
                                      aggFunc: "sum",
                                      filter: "agNumberColumnFilter",
                                      filterParams: {
                                          cellHeight: 20,
                                          debounceMs: 1000
                                      }
                                  }]

                              }
                        />
                    </VsiBubble>
                </div>
            )}
        </Card>
    );
}
